import { render, staticRenderFns } from "./newspecial.vue?vue&type=template&id=4954ed88&scoped=true"
import script from "./newspecial.vue?vue&type=script&lang=js"
export * from "./newspecial.vue?vue&type=script&lang=js"
import style0 from "./newspecial.vue?vue&type=style&index=0&id=4954ed88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954ed88",
  null
  
)

export default component.exports